<template>
  <div class="headerNav">
    <div
      class="main_head"
      v-if="!$route.meta.login && !$route.meta.Homepage && !$route.meta.newHome"
    >
      <div @click="gopage">
        <div
          v-if="$store.state.user.userInfo.tongxin"
          class="main_head_logo center"
          style="width: 18%;cursor: pointer"
        >
          <!-- {{ $store.state.userInfo.region }} -->
          <!-- {{ nameList.iotLogoUrl }} -->
          <!-- {{ $store.state.user.userInfo.natureId }} -->
          <!-- {{ $store.state.user.userInfo.tongxin }} -->
          <img
            :src="$store.state.iotLogoUrl"
            style="width: 31px;height: 36px;"
          />
          <el-tooltip
            class="item"
            effect="light"
            :content="title"
            placement="bottom"
            v-model="showTitle"
            :disabled="!$store.state.user.userInfo.tongxin"
          >
            <span style="font-size: 20px;font-weight: bold;">{{
              $store.state.iotSystemTitle
            }}</span>
          </el-tooltip>
          <!-- <span v-else>同人消防物联网监控平台</span> -->
        </div>
        <!-- <div
          v-else-if="$store.state.user.userInfo.isWenwu"
          class="main_head_logo center"
          style="width: 18%;cursor: pointer"
        >
          <img src="@/assets/img/logo1.png" style="width: 22px; height: 32px" />
          <el-tooltip
            class="item"
            effect="light"
            :content="title"
            placement="bottom"
          >
            <span style="font-size: 15px"
              >青岛八大关近代建筑预防性保护平台</span
            >
          </el-tooltip>
        </div> -->

        <div v-else class="main_head_logo center" style="cursor: pointer">
          <img src="@/assets/img/applogo1.png" style="width: 34px; height: 34px" />

          <el-tooltip
            class="item"
            effect="light"
            :content="title"
            placement="bottom"
            :disabled="$store.state.user.userInfo.natureId == 3"
          >
            <span>平度文物安全监管平台</span>
            <!-- <span>同人智慧消防综合管理平台</span> -->
          </el-tooltip>
          <!-- <span v-else>同人消防物联网监控平台</span> -->
        </div>
      </div>

      <div class="main_end">
        <ul class="main_navigation_bar align-center inline-hide">
          <li class="tnav" :class="active == '/' ? 'active' : ''">
            <router-link to="/">首页</router-link>
          </li>
          <li
            class="tnav"
            :class="active == nav.meta.title ? 'active' : ''"
            v-for="nav in permission.addRoutes"
            v-if="nav.meta && nav.meta.title"
          >
            <router-link :to="''" tag="a">{{
              nav.meta ? nav.meta.title : ""
            }}</router-link>
            <i
              class="fa fa-angle-down"
              v-if="nav.children && nav.children.length"
            ></i>
            <ul class="main_navigation_shu_bar">
              <router-link
                tag="li"
                :to="{
                  path: `${child.path}`,
                  query: child.outline ? { url: child.outline } : null,
                }"
                v-for="child in nav.children"
              >
                {{ child.meta.title }}
              </router-link>
            </ul>
          </li>
          <li class="tnav" v-if="$store.state.isDev">
            <router-link :to="'/'" tag="a">devlop</router-link>
            <i class="fa fa-angle-down"></i>

            <ul class="main_navigation_shu_bar">
              <router-link tag="li" to="/makeForm">makeForm</router-link>
              <li @click="weihuAdd = true">维护时间</li>
            </ul>
          </li>
        </ul>

        <div class="main_user_weather">
          <div class="main_clock_weather">
            <!-- <div class="main_clock" v-if="nowTime">
            <div class="time">{{ nowTime.split(" ")[1] }}</div>
            <div class="date">{{ nowTime.split(" ")[0] }}</div>
          </div> -->
            <div class="main_weather" v-if="weather.temperature">
              <div class="weather"><i :class="'wi wi-' + weatherIcon"></i></div>
              <div class="wd">
                <div class="ssd">{{ weather.temperature }}℃</div>
                <div class="tq">{{ weather.weather }}</div>
              </div>
              <div class="wind">
                <div class="w-x">
                  <i :class="'wi wi-wind wi-towards-' + winddirectionIcon"></i>
                </div>
                <div class="w-level">
                  {{ weather.winddirection }}风{{ weather.windpower }}级
                </div>
              </div>
            </div>
          </div>
          <div class="main_user_zoom">
            <el-dropdown @command="select">
              <div class="head-user">
                <div class="head-user-img">
                  <img src="@/assets/img/default-head.png" />
                </div>
                <div class="head-user-role">
                  <!-- {{
                  $store.state.userInfo.username ||
                  $store.state.userInfo.company_num
                }} -->
                  {{ $store.state.user.userInfo.nickName }}
                  <i class="fa fa fa-caret-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <!-- {{ $store.state.user.userInfo.tongxin }} -->
                <!-- <template v-if="!$store.state.user.userInfo.tongxin">
                  <el-dropdown-item command="linkto">访问官网</el-dropdown-item>
     
                </template> -->
                <!--<el-dropdown-item>系统设置</el-dropdown-item>-->
                <!--<el-dropdown-item>个人中心</el-dropdown-item>-->
                <el-dropdown-item command="changePass"
                  >修改密码</el-dropdown-item
                >
                <!-- {{ $store.state.user.userInfo.nickName }} -->
                <!-- {{ $store.state.user.userInfo.tongxin }} -->
                <!-- <template
                  v-if="
                    $store.state.user.userInfo.userId == 1 ||
                      ($store.state.user.userInfo.natureId == 3 &&
                        $store.state.user.userInfo.tongxin)
                  "
                >
                  <el-dropdown-item command="editTitle"
                    >系统名称修改</el-dropdown-item
                  >
                </template> -->
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                <!-- {{ $store.state.userInfo.userName }} -->
              </el-dropdown-menu>
            </el-dropdown>

            <el-dialog
              :visible.sync="weihuAdd"
              width="30%"
              :show-close="true"
              v-if="$store.state.isDev"
              style="z-index: 999 !important;"
            >
              <el-form v-model="weihufm">
                <el-date-picker
                  v-model="weihufm.starttime"
                  type="datetime"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-date-picker
                  class="mt20"
                  v-model="weihufm.endtime"
                  type="datetime"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form>
              <div class="center mt20">
                <el-button type="primary" @click="weihu">保存</el-button>
              </div>
            </el-dialog>

            <el-dialog
              title="修改密码"
              :visible.sync="showDia"
              width="500px"
              :append-to-body="true"
              :close-on-click-modal="false"
            >
              <el-form
                ref="passForm"
                :model="passForm"
                label-width="110px"
                :rules="rules"
              >
                <el-form-item label="请输入旧密码" prop="old_password">
                  <el-input
                    placeholder="请输入旧密码"
                    v-model="passForm.old_pwd"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item label="请输入新密码" prop="new_password">
                  <el-input
                    placeholder="请输入新密码"
                    v-model="passForm.new_pwd"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item label="请确认密码" prop="new_confirm">
                  <el-input
                    placeholder="请确认密码"
                    v-model="passForm.confirm"
                    show-password
                  ></el-input>
                </el-form-item>
              </el-form>
              <div class="center mt20">
                <el-button type="primary" @click="passSubmit" size="small"
                  >提交</el-button
                >
                <el-button @click="resetchange(true)" size="small"
                  >取消</el-button
                >
              </div>
            </el-dialog>

            <el-dialog
              title="账号绑定"
              :visible.sync="showBind"
              width="500px"
              :append-to-body="true"
              :close-on-click-modal="false"
            >
              <el-form
                ref="passForm"
                :model="bindForm"
                label-width="110px"
                :rules="rules"
              >
                <el-form-item label="请输入手机号" prop="old_password">
                  <el-input
                    placeholder="请输入手机号"
                    v-model="bindForm.phone"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div class="center mt20">
                <el-button type="primary" @click="bindAccount" size="small"
                  >提交</el-button
                >
                <el-button @click="accCancle" size="small">取消</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTime, getWeather, logout, getMenu } from "../api/common.js";
import Crypto from "../utils/crypto";
import { editName } from "@/api/home";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["permission", "isWaring"]),
  },
  data() {
    return {
      navList: [],
      showDia: false,
      time: 60,
      btntxt: "获取验证码",
      disabled: false,
      showBind: false, // 双邦弹框开关
      bindForm: {
        phone: "",
        code: "",
      },
      allList: [],
      loading: true,
      menuList: [],
      // outLineList:[{fa_menu_name:'基础设置',menu_name:'执法记录',out_href:"aaa"}], // 外部链接
      isFullScreen: false,
      nowTime: "",
      weather: {},
      rules: {},
      timer: null,
      passForm: {
        old_pwd: "",
        new_pwd: "",
        confirm: "",
      },
      weatherIcon: "",
      winddirectionIcon: "",
      weihuAdd: false,
      weihufm: {
        starttime: "",
        endtime: "",
      },
      active: "",
      title: "点击返回上一级",
      showTitle: false,
      iotSystemTitle: "",
      iotLogoUrl: "",
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.setTime();
    this.setWeather();
    if (this.$store.state.user.userInfo.natureId == 2) {
      this.title = "返回上一级";
    }

    // setTimeout(() => {
    // }, 4000);
    // this.getMenu();
    // setInterval(()=>{console.log(this.$store.state.userInfo.region)}, 1000); //3小时更新一次天气

    setInterval(this.setWeather, 3 * 60 * 60 * 1000); //3小时更新一次天气
  },

  watch: {
    "$route.path": {
      handler(val, old) {
        this.checkRouter(val);
        if (this.$store.state.user.userInfo.region == 2) {
          this.setWeather();
        }
      },
      immediate: true,
    },
    "permission.addRoutes"(val) {},

    "$store.state.iotSystemTitle": {
      handler(val, old) {
        this.getList(val);
      },
      immediate: true,
      deep: true,
    },
    "$store.state.iotLogoUrl": {
      handler(val, old) {
        this.getList(val);
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    accBindCancle() {
      this.$confirm("确定解除绑定该账号吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          this.$remove(
            `/things/frontPage/${this.$store.state.user.userInfo.userId}`
          ).then((res) => {
            this.$message({ message: res.msg, type: "success", duration: 700 });
            this.$store.dispatch("GetInfo");
          });
        })
        .catch(() => {});
    },
    // 获取验证码
    getCode() {
      if (this.bindForm.phone) {
        if (this.bindForm.phone.length !== 11) {
          this.$message.warning("请输入正确手机号");
          return;
        }
        this.time = 60;
        this.disabled = true;
        this.timerInterval();
        // let data = { phone: this.bindForm.phone };
        this.$get("/things/frontPage/getSmsCodeBind", data).then((res) => {
          this.$message({ message: res.msg, type: "success", duration: 700 });
        });
      } else {
        this.$message.warning("请输入正确手机号");
      }
    },
    // 倒计时
    timerInterval() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timerInterval, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    // 账号绑定
    accBind() {
      this.showBind = true;
    },
    accCancle() {
      this.clearBind();
      this.showBind = false;
    },
    // 绑定动作
    bindAccount() {
      // 准备调接口
      console.log(this.bindForm);
      this.$post("/things/frontPage/accountBind", this.bindForm).then((res) => {
        this.$message({ message: res.msg, type: "success", duration: 700 });
        this.$store.dispatch("GetInfo");
        this.clearBind();
        this.showBind = false;
      });
    },
    clearBind() {
      this.bindForm = {};
    },
    changePass() {
      this.showDia = true;
    },
    passSubmit() {
      console.log(this.passForm);
      var { old_pwd, new_pwd, confirm } = this.passForm;
      if (!old_pwd || !new_pwd || !confirm) {
        this.$message.error("请填写必填信息");
        return false;
      } else if (confirm !== new_pwd) {
        this.$message.error("输入的两次密码不相同");
        return false;
      } else if (old_pwd === new_pwd) {
        this.$message.error("新密码不可以与旧密码相同");
        return false;
      }

      this.$post("/user/xiugaimima", this.passForm).then((res) => {
        this.$message({ message: res.msg, type: "success", duration: 700 });
        this.resetchange();
        this.showDia = false;
        setTimeout(() => {
          this.$store.commit("clearUser");

          this.$router.replace({
            path: "/login",
          });
        }, 1400);
      });
    },
    resetchange(a) {
      this.passForm = { old_pwd: "", new_pwd: "", confirm: "" };
      if (a) {
        this.showDia = false;
      }
    },
    chaneNum(v) {
      var str = Number(v) <= 9 ? `0${v}` : v;
      return str;
    },
    weihu() {
      this.$post("/role/addmaintain", this.weihufm).then((res) => {
        this.$message({ message: res.msg, type: "success", duration: 700 });
      });
    },
    select(val) {
      this[val]();
    },
    // logout() {
    //   logout({ token: this.$store.state.token }).then((res) => {
    //     this.$store.commit("clearUser");

    //     this.$router.replace({
    //       path: "/login",
    //     });
    //   });
    // },
    async logout() {
      // console.log(window.close());
      // window.opener = null;
      //   window.open('', '_self');
      //   window.close();

      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // if (jumpLocation == 1) {
        //   console.log("正常退出");
        this.$store.dispatch("LogOut").then(() => {
          this.$router.replace({
            path: "/login",
          });
        });
        // } else if (jumpLocation == 2) {
        //   console.log("整个页面关闭");

        // }
      });
    },
    linkto() {
      window.open("https://www.tongren119.com/");
      // var date = new Date();
      // var time = `${date.getFullYear()}-${this.chaneNum(date.getMonth() + 1)}-${date.getDate()}`;
      // var obj = { user: this.$local.get("account").username, time };
      // this.$post("/website/automaticlogin", obj).then((res) => {
      //   window.open(`http://www.tongren119.com?info=${res}`, "_blank");
      // });
    },
    getMenu() {
      this.$post("/menu/thisusermenu").then((res) => {
        this.navList = res.data;
        for (let key in this.navList) {
          this.menuList.push(this.navList[key].menu_href);

          if (
            this.navList[key].menu_name == "基础设置" &&
            this.$store.state.user.company.cCompanyNum === "aaa"
          ) {
            this.navList[key].tr_power_hson.push(
              {
                menu_name: "执法记录",
                menu_href: "webview",
                outline:
                  "https://trtest.tongren119.com/#/login?YXV0b2xvZ2luPTEmdHlwZT0y",
              },
              {
                menu_name: "消防预案",
                menu_href: "webview",
                outline:
                  "https://www.anfangxing.cn/shandong/index.html#!/commanding/a15cdf66-00e0-4dbe-8d6f-654d9d7caa66/a1b3b4d1-c0d8-49c3-9b07-dde379ea09a1",
              }
            );
          }

          if (this.navList[key].tr_power_hson) {
            this.navList[key].tr_power_hson.forEach((menu) => {
              this.menuList.push(menu.menu_href);
            });
          }
        }
      });
      this.$post("/menu/findall", { page: 1, limit: 100 }).then((res) => {
        // console.log(res.data)
        let arr = res.data.list;
        for (let key in arr) {
          this.allList.push(arr[key].menu_href);
        }
        this.checkRouter(this.$route.path);
      });
    },
    outline(it) {
      // if(it.outline){
      //   window.location.href = it.outline
      // }
    },
    setTime() {
      // getTime().then((data) => {
      // let time = data.sysTime2.replace(/-/g, "/");
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ")
        .replace(/-/g, "/");

      let timeLine = new Date(time).getTime();
      this.nowTime = new Date(timeLine).Format("yy年MM月dd日 hh:mm:ss");
      this.$local.save("nowtime", this.nowTime);

      this.timer = setInterval(() => {
        timeLine += 1000;
        this.nowTime = new Date(timeLine).Format("yy年MM月dd日 hh:mm:ss");
        this.$local.save("nowtime", this.nowTime);
      }, 1000);
      // });
    },
    setWeather() {
      let code = 370200;
      if (this.$store.state.userInfo.region == 2) {
        code = 370100;
      }
      // console.log(this.$store.state.userInfo.region == 2,this.$store.state.userInfo.region,code);
      getWeather({
        key: "c2033986fe11749475852e35030fe835",
        city: code,
        // 370100
        extensions: "base",
      }).then((data) => {
        console.log(data,6666666666661);
        this.weather = data.lives[0];
        // console.log(this.weather);
        this.weatherIcon = this.getweatherName(this.weather.weather);
        this.winddirectionIcon = this.getwind(this.weather.winddirection);
      });
    },
    checkRouter(val) {
      setTimeout(() => {
        let path = this.permission.addRoutes?.find((item) => {
          return (
            item.path == val ||
            item.children?.find((it) => {
              return (
                it.path == val ||
                it.children?.find((route) => {
                  return route.path == val;
                })
              );
            })
          );
        })?.meta.title;
        // console.log(path, this.permission.addRoutes);
        if (path) {
          this.$local.save("menuActive", path);
          this.active = path;
        } else {
          this.active = this.$local.get("menuActive") || "";
        }
        if (val == "/") this.active = "/";
        if (
          this.menuList.indexOf(val.substr(1)) === -1 &&
          this.allList.indexOf(val.substr(1)) > -1
        ) {
          if (this.$route.path !== "/404" && this.$route.path !== "/") {
            this.$router.replace("/404");
          }
        }
      });
    },
    getweatherName(text) {
      //获取天气ICON名
      var map = {
        雨: "rain",
        晴: "day-sunny",
        雪: "snow",
        风: "wind",
        云: "cloudy",
        雾: "fog",
        雷: "thunderstorm",
        尘: "day-haze",
        霾: "day-haze",
        沙: "day-haze",
      };
      for (var key in map) {
        if (text.indexOf(key) !== -1) {
          return map[key];
        }
      }
      return null;
    },
    getwind(text) {
      //获取风向
      var map = {
        东: "e",
        南: "s",
        西: "w",
        北: "n",
      };
      var str = "";
      for (var key in text) {
        str += map[text[key]];
      }
      return str
        .split("")
        .reverse()
        .join("");
    },
    FullScreen() {
      var elem = document.body;
      if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen();
        this.isFullScreen = true;
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
        this.isFullScreen = true;
      } else if (elem.requestFullScreen) {
        elem.requestFullscreen();
        this.isFullScreen = true;
      } else {
        this.$notify({
          title: "提示",
          message: "浏览器不支持全屏API或已被禁用",
        });
      }
    },
    noFullScreen() {
      var elem = document;
      if (elem.webkitCancelFullScreen) {
        elem.webkitCancelFullScreen();
        this.isFullScreen = false;
      } else if (elem.mozCancelFullScreen) {
        elem.mozCancelFullScreen();
        this.isFullScreen = false;
      } else if (elem.cancelFullScreen) {
        elem.cancelFullScreen();
        this.isFullScreen = false;
      } else if (elem.exitFullscreen) {
        elem.exitFullscreen();
        this.isFullScreen = false;
      } else {
        this.$notify({
          title: "提示",
          message: "浏览器不支持全屏API或已被禁用",
        });
      }
    },
    async gopage() {
      if (this.$store.state.user.userInfo.natureId == 2) {
        await this.$router.push("/");
      } else if (this.$store.state.user.userInfo.tongxin) {
        this.$router.push("/homePage1");
      } else {
        this.$router.push("/");
      }
    },
    editTitle() {
      this.$router.push("/editTitle");
    },
    getList() {
      
      if (
        this.$store.state.user.userInfo.natureId == 3 &&
          this.$store.state.user.userInfo.tongxin
      ) {
        editName({ type: 3 }).then((res) => {
          // console.log(999999999);
          // console.log(res);
          this.iotSystemTitle = res.data.iotSystemTitle;
          this.$store.state.iotSystemTitle = res.data.iotSystemTitle;
          this.$store.state.iotLogoUrl = res.data.iotLogoUrl;
          this.$store.commit("setFavicon", res.data.faviconUrl);
          this.$store.commit("setTitle", res.data.faviconTitle);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.headerNav {
  width: 100%;
  height: 60px;
}
.main_head {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.tnav {
  z-index: 33;
  display: flex;
  align-items: center;
  height: 100%;
  .main_navigation_shu_bar {
    display: none;
  }

  i {
    margin-left: 5px;
  }

  &:hover {
    .main_navigation_shu_bar {
      display: block;
    }

    font-weight: 700;

    i,
    a {
      color: #fff;
      font-weight: 800;
      font-size: 18px;
    }
  }
}
.active {
  i,
  a {
    font-weight: 800;
    font-size: 18px;
  }
}
.head-user {
  .main_navigation_shu_bar_manage {
    display: none;

    i {
      margin-right: 5px;
    }
  }

  &:hover {
    .main_navigation_shu_bar_manage {
      display: block;
    }
  }
}
.main_navigation_shu_bar > li {
  font-weight: 500;
}

.v-model {
  z-index: 500 !important;
}
</style>
